const base_url = process.env.REACT_APP_BASE_URL;

export default base_url;
